// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subject-remark{position:absolute;top:80px;left:10px;width:200px;background-color:rgba(0,0,0,.2)}", ""]);
// Exports
module.exports = exports;
